import React, { useState } from "react";
import Layout from "../../Layout";
import Container from "../../components/Container";
import { FaEdit } from "react-icons/fa";
import { Button, Switchi } from "../../components/Form";
import { subscriptionData } from "../../components/Datas";

function Subscriptions() {
	const [show, setShow] = useState(false);
	const [annual, setAnnual] = useState(true);

	return (
		<Layout>
			<Container className="flex flex-col min-w-80 max-w-80 px-5 py-6 items-center text-gray-900/80 bg-white/60 rounded-lg">
				<div className="flex flex-1 flex-col w-full divide-y-[1px]">
					<div className="flex flex-1 flex-col py-2 mb-1">
						<div className="text-xs my-1">License</div>
						<div className="text-md ">Free Trial</div>
					</div>
					<div className="flex flex-1 flex-col py-2 mb-1">
						<div className="text-xs my-1">Limit</div>
						<div className="text-md ">Up to 400 cases per month</div>
					</div>
					<div className="flex flex-1 flex-col py-2 mb-1">
						<div className="text-xs my-1">Expiry Date</div>
						<div className="text-md ">01/31/2024</div>
					</div>
				</div>
				<Button
					className="md:max-w-[90%] items-center text-lg !text-subMain bg-white border-2 border-subMain"
					// Icon={() => <FaEdit size={16} />}
					label={!show ? "Change" : "Hide"}
					onClick={() => setShow(!show)}
				/>
			</Container>
			{show && (
				<div className="flex flex-1 flex-col items-center">
					<div className="flex text-xl mt-2">Pick your Plan</div>
					<div className="flex my-6 items-center">
						<span className="mr-5">Annual</span>
						<Switchi checked={annual} onChange={() => setAnnual(!annual)} />
					</div>
					<div className="flex flex-1 w-full h-auto mt-2 mb-5 justify-evenly">
						{subscriptionData.map((item, index) => (
							<div key={index} className="flex flex-1 flex-col max-w-[30%] items-center rounded-2xl overflow-hidden shadow-lg">
								<div className="flex flex-1 w-full bg-subMain justify-center py-4 text-xl text-white">
									{item.name}
								</div>
								<div className="flex flex-1 w-full flex-col text-lg text-gray-900/80 items-center px-4">
									<div className="mt-3 mb-4">Up to {item.cases} cases per month</div>
									{annual && (<div className="line-through decoration-red-400">{annual ? item.price * 12 : item.price } BAM</div>)}
									<div className="flex">
										<div className="font-semibold mr-1">{annual ? item.discount_price : item.price} BAM</div>
										{annual ? 'annualy' : 'monthly'}
									</div>
									{annual && (<div className="flex">
										Save
										<div className="font-semibold ml-1">360 BAM</div>
									</div>)}
									<Button className={"mt-6 mb-4"} label={"SELECT"} />
								</div>
							</div>
						))}
					</div>
				</div>
			)}
		</Layout>
	);
}

export default Subscriptions;
